import { render, staticRenderFns } from "./ProductFamilyTextBlock.vue?vue&type=template&id=9c5ac040&"
import script from "./ProductFamilyTextBlock.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports